import {
  BubbleCircleV2,
  BubbleHaloCircleV2,
  BubblePulseCircleV2,
} from '@/components/public/Visualisations/BubblesV2/Entities'
import { BubbleMetadata } from '@/components/public/Visualisations/BubblesV2/Metadata'
import { Shapes } from '@/components/public/Visualisations/types'
import Konva from 'konva'

export class BubbleGroupV2 extends Konva.Group implements Shapes.Group {
  private _bubbleMetadata: BubbleMetadata
  capabilities: Shapes.Capability[] = [Shapes.Capability.Fadable]
  entities: Shapes.Entity[] = []
  _bubble: BubbleCircleV2
  _halo: BubbleHaloCircleV2
  _pulse: BubblePulseCircleV2

  constructor(bubbleMetadata: BubbleMetadata) {
    super()

    this._bubble = new BubbleCircleV2(bubbleMetadata)
    this.addShape(this._bubble)
    this._halo = new BubbleHaloCircleV2(bubbleMetadata.haloMetadata)
    this.addShape(this._halo)
    this._pulse = new BubblePulseCircleV2(bubbleMetadata.pulseMetadata)
    this.addShape(this._pulse)

    this.position(bubbleMetadata.destinationPosition)

    // When the d3 simulation updates the Bubbles coordinates we also need to update the
    // Konva Circles, the most efficient way to do this is to pass a callback to each Bubble
    // that will update the Circle coordinates every time the Bubble coordinates are updated
    bubbleMetadata.onPositionChanged((position) => {
      this.position(position)
    })

    this._bubbleMetadata = bubbleMetadata
    this.refresh()
  }

  get key() {
    return this.path.toString()
  }

  get path() {
    return this._bubbleMetadata.path
  }

  get center() {
    return this.position()
  }

  refresh() {
    this._bubble.refresh()
    this._halo.refresh()
    this._pulse.refresh()
  }

  private addShape(shape: Shapes.Shape) {
    this.entities.push(shape)
    this.add(shape)
  }
}
